import { TextColorType } from "@/lib/main";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLHeadingElement>["className"];
  color?: TextColorType;
  fontWeight?: 500 | 600;
  id?: HTMLAttributes<HTMLHeadingElement>["id"];
  lineHeight?: number;
  textAlign?: CSSProperties["textAlign"];
}>;

export default function Heading2({
  children,
  className,
  color,
  fontWeight,
  id,
  lineHeight,
  textAlign,
}: Props) {
  const styles: CSSProperties = {
    color: `var(--color-text-${color || "primary"})`,
    fontSize: "var(--font-size-heading-2)",
    fontWeight: fontWeight || 500,
    lineHeight: lineHeight || "var(--line-height-heading)",
    textAlign: textAlign || "start",
  };

  return (
    <h2 className={className} id={id} style={styles}>
      {children}
    </h2>
  );
}
